import {
  ACTION_EDIT_CORPORATION_FISCAL_NUMBER__REQUEST,
  ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS,
  ACTION_EDIT_CORPORATION_FISCAL_NUMBER__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_CORPORATION_FISCAL_NUMBER__REQUEST:
    case ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS:
      return null;

    case ACTION_EDIT_CORPORATION_FISCAL_NUMBER__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
